<app-content-header title="{{ 'Chat' | translate }}" [breadcrumb]="breadcrumb"></app-content-header>
<kendo-tabstrip #tabs (tabSelect)="onTabSelect($event)">
    <kendo-tabstrip-tab [selected]="initialSelectedTabIndex === 0">
        <ng-template kendoTabTitle>
            <span class="d-flex align-items-center">
                <span>{{ 'General' | translate }}</span>
                @if (unreadCounts.general > 0) {
                    <span class="badge badge-danger ml-1">
                        <fa-icon [icon]="['fas', 'comment']"></fa-icon>
                        {{ unreadCounts.general }}
                    </span>
                }
            </span>
        </ng-template>
        <ng-template kendoTabContent>
            <app-tab-chat mode="general"></app-tab-chat>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [selected]="initialSelectedTabIndex === 1">
        <ng-template kendoTabTitle>
            <span class="d-flex align-items-center">
                <span>{{ 'Vessel Visit' | translate }}</span>
                @if (unreadCounts.vesselVisit > 0) {
                    <span class="badge badge-danger ml-1">
                        <fa-icon [icon]="['fas', 'comment']"></fa-icon>
                        {{ unreadCounts.vesselVisit }}
                    </span>
                }
            </span>
        </ng-template>
        <ng-template kendoTabContent>
            <app-tab-chat mode="vesselVisit"></app-tab-chat>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [selected]="initialSelectedTabIndex === 2">
        <ng-template kendoTabTitle>
            <span class="d-flex align-items-center">
                <span>{{ 'Service Request' | translate }}</span>
                @if (unreadCounts.serviceRequest > 0) {
                    <span class="badge badge-danger ml-1">
                        <fa-icon [icon]="['fas', 'comment']"></fa-icon>
                        {{ unreadCounts.serviceRequest }}
                    </span>
                }
            </span>
        </ng-template>
        <ng-template kendoTabContent>
            <app-tab-chat mode="serviceRequest"></app-tab-chat>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [selected]="initialSelectedTabIndex === 3">
        <ng-template kendoTabTitle>
            <span class="d-flex align-items-center">
                <span>{{ 'Storage Document' | translate }}</span>
                @if (unreadCounts.storageDocument > 0) {
                    <span class="badge badge-danger ml-1">
                        <fa-icon [icon]="['fas', 'comment']"></fa-icon>
                        {{ unreadCounts.storageDocument }}
                    </span>
                }
            </span>
        </ng-template>
        <ng-template kendoTabContent>
            <app-tab-chat mode="storageDocument"></app-tab-chat>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [selected]="initialSelectedTabIndex === 4">
        <ng-template kendoTabTitle>
            <span class="d-flex align-items-center">
                <span>{{ 'Amendment Document' | translate }}</span>
                @if (unreadCounts.amendmentDocument > 0) {
                    <span class="badge badge-danger ml-1">
                        <fa-icon [icon]="['fas', 'comment']"></fa-icon>
                        {{ unreadCounts.amendmentDocument }}
                    </span>
                }
            </span>
        </ng-template>
        <ng-template kendoTabContent>
            <app-tab-chat mode="amendmentDocument"></app-tab-chat>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="{{ 'Sent' | translate }}" [selected]="initialSelectedTabIndex === 5">
        <ng-template kendoTabContent>
            <app-tab-chat mode="sent"></app-tab-chat>
        </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>
